// local storage keys
export const LS_DRC_PREFIX = '/drc';
export const LS_DRC_TRIPS = `${LS_DRC_PREFIX}/trips`;
export const LS_DRC_IDENTITY_ANONYMOUS = 'TEMP';
export const LS_DRC_TRIPS_ANONYMOUS = `${LS_DRC_TRIPS}/TEMP`;
export const LS_DRC_CHECKLIST = 'checklist';

// events
export const HEADER_INITIALIZED_EVENT = 'headerInitialized';